import { createSelector } from 'reselect';

export const getError = createSelector(
  state => state.error,
  error => ({ title: error.title, message: error.message, seen: error.seen, code: error.code })
);
